import { render, staticRenderFns } from "./InstantMessagerEvent.vue?vue&type=template&id=41263490&"
import script from "./InstantMessagerEvent.vue?vue&type=script&lang=js&"
export * from "./InstantMessagerEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports